<template>
  <CourseSearchPage :filter-fields="filterFields" />
</template>

<script>
import { mapState } from 'vuex'
import CourseSearchPage from '~contemporaryTheme/pages/courses/index'

async function getSubjectCodes({ school, $axios }) {
  const subjectCodes = await $axios.$get(
    `/cm/${school}/codes/subjectCodes?excludeWithoutCourses=true`,
    {
      skip: 0,
      limit: 1000,
      returnFields: ['subjectCode', 'description'],
    }
  )
  return Object.values(subjectCodes).map((sc) => ({
    label: `${sc.description} (${sc.subjectCode})`,
    value: sc.subjectCode,
  }))
}

export default {
  components: {
    CourseSearchPage,
  },
  data() {
    return {
      subjectCodeOptions: [],
    }
  },
  computed: {
    ...mapState('departments', {
      chosenDepartments: (state) => state.chosen || state.all,
    }),
    ...mapState('settings', ['school']),
    filterFields() {
      return [
        {
          label: 'Departments',
          placeholder: 'Filter By Departments',
          questionId: 'departments',
          dataKey: 'departments',
          custom: false,
          type: 'searchSelect',
          questionType: 'select',
          config: {
            options: this.departmentOptions,
          },
          visibility: true,
          tooltipEnabled: false,
          filter: {
            group: 'course',
            id: 'departments-courses',
            inputType: 'select',
            name: 'departments',
            type: 'is',
          },
        },
        {
          label: 'Subject Code',
          placeholder: 'Filter By Subject Code',
          questionId: 'subjectCode',
          dataKey: 'subjectCode',
          custom: false,
          type: 'searchSelect',
          questionType: 'select',
          config: {
            options: this.subjectCodeOptions,
          },
          visibility: true,
          tooltipEnabled: false,
          filter: {
            group: 'course',
            id: 'subjectCode-courses',
            inputType: 'select',
            name: 'subjectCode',
            type: 'is',
          },
        },
      ]
    },
    departmentOptions() {
      return this.chosenDepartments.map((item) => {
        return { label: item.displayName, value: item.id }
      })
    },
  },
  async created() {
    this.subjectCodeOptions = await getSubjectCodes({
      school: this.school,
      $axios: this.$axios,
    })
  },
}
</script>
